module.exports = __webpack_public_path__ + "static/img/zt4_tab3.d81f141.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/zt4_tab3.jpg
// module id = IJuy
// module chunks = 171